import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WLogo from "../assets/TravelXOXO 1.png";
import DLogo from "../assets/TravelXOXO 2.png";

export default function PrivacyPolicy() {
  const [theme, setTheme] = useState("dark");

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
  }, [theme]);

  return (
    <div className="bg-gray-100 text-black dark:bg-black dark:text-white min-h-screen">

      {/* HEADER */}
      <header className="bg-white dark:bg-black flex items-center justify-between px-16 py-4 border-b border-black/10 dark:border-white/10">
        <img src={WLogo} className="h-8 dark:hidden block" alt="TravelXOXO" />
        <img src={DLogo} className="h-8 hidden dark:block" alt="TravelXOXO" />

        <nav className="hidden md:flex gap-6 text-sm text-black/70 dark:text-white/70">
          <Link to="/" className="hover:text-black dark:hover:text-white">Home</Link>
          <Link to="/requestform" className="hover:text-black dark:hover:text-white">Request Stickers</Link>
            <Link to="/privacypolicy" className="hover:text-black dark:hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-black dark:hover:text-white">Terms of Use</Link>
        </nav>

        <button
          onClick={toggleTheme}
          className="w-12 h-12 rounded-full bg-orange-600 text-white flex items-center justify-center hover:scale-105 transition"
          title="Toggle theme"
        >
          {theme === "dark" ? "🌞" : "🌙"}
        </button>
      </header>

      {/* CONTENT */}
      <section className="max-w-5xl mx-auto px-6 md:px-16 py-16">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
          Privacy Policy – TravelXOXO Lost and Found Tags
        </h1>

        <p className="text-sm text-black/60 dark:text-white/60 mb-10">
          Effective Date: December 15, 2025 | Last Updated: December 15, 2025
        </p>

        <div className="space-y-10 text-sm leading-relaxed text-black/80 dark:text-white/80">

          <section>
            <h2 className="text-xl font-bold mb-3">1. Introduction</h2>
            <p>
              Hourglass Essentials Pvt Ltd operates the travelXOXO Lost and Found Tags service
              (https://app.travelxoxo.io). This Privacy Policy explains how we collect, use,
              disclose, and protect your information when you use our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">2. Information We Collect</h2>

            <h3 className="font-semibold mt-4">2.1 Registration Information</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Full name</li>
              <li>Email address</li>
              <li>Primary and secondary phone numbers</li>
              <li>Product name</li>
              <li>Office or organization name</li>
            </ul>

            <h3 className="font-semibold mt-4">2.2 Automatically Collected Information</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>QR scan timestamps and locations</li>
              <li>Device and operating system</li>
              <li>IP address</li>
              <li>Browser details and analytics</li>
            </ul>

            <h3 className="font-semibold mt-4">2.3 Cookies</h3>
            <p>
              We use cookies and similar technologies to improve user experience and analyze usage.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">3. How We Use Your Information</h2>
            <ul className="list-disc ml-6">
              <li>Create and maintain Lost and Found pages</li>
              <li>Enable QR-based item recovery</li>
              <li>Facilitate communication</li>
              <li>Customer support and service updates</li>
              <li>Marketing communications</li>
              <li>Legal compliance and security</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">4. Information Sharing</h2>
            <p className="mb-3">
              Registration information becomes visible when a QR code is scanned.
            </p>
            <ul className="list-disc ml-6">
              <li>Service providers</li>
              <li>Legal authorities</li>
              <li>Business transfers</li>
              <li>Anonymized marketing analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">5. Data Retention</h2>
            <p>
              Data is retained for service delivery, compliance (minimum 3 years),
              and legitimate business purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">6. Your Rights</h2>
            <ul className="list-disc ml-6">
              <li>Access and correction</li>
              <li>Marketing opt-out</li>
              <li>Data deletion requests</li>
              <li>Cookie control</li>
            </ul>
            <p className="mt-2">
              Contact: <span className="font-medium">itadmin@companystore.io</span>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">7. Data Security</h2>
            <p>
              Encryption, secure infrastructure, access controls, and audits are used.
              Absolute security cannot be guaranteed.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">8. Children’s Privacy</h2>
            <p>
              This service is not intended for individuals under 18 years of age.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">9. International Transfers</h2>
            <p>
              Data may be processed outside your country with appropriate safeguards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">10. Policy Updates</h2>
            <p>
              Updates will be communicated via email or platform notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">11. Contact & Grievance Officer</h2>
            <p className="font-medium mt-2">Hourglass Essentials Pvt Ltd</p>
            <p>#39 Krishna Reddy Colony, Domlur Layout, Bangalore – 560071, India</p>
            <p>Email: itadmin@companystore.io | Phone: +91 9632950798</p>

            <p className="mt-4">
              <span className="font-semibold">Grievance Officer:</span><br />
              R Roger Daniel Fernando, IT Solutions Manager<br />
              Response timeframe: 30 days
            </p>
          </section>

          <p className="text-xs text-black/60 dark:text-white/60">
            Document Version 1.0 | Governing Law: India | Jurisdiction: Bangalore
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white dark:bg-black border-t border-black/10 dark:border-white/10 py-8">
  <div className="max-w-5xl mx-auto px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-black/60 dark:text-white/60">

    <div>
      © {new Date().getFullYear()} TravelXOXO. All rights reserved.
    </div>

    <div className="flex gap-6">
      <Link
        to="/privacypolicy"
        className="hover:text-black dark:hover:text-white transition"
      >
        Privacy Policy
      </Link>
      <Link
        to="/terms"
        className="hover:text-black dark:hover:text-white transition"
      >
        Terms of Use
      </Link>
    </div>

  </div>
</footer>

    </div>
  );
}
